<template>
  <div>
    <b-container fluid class="content">
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <el-row :gutter="10">
                <el-col :span="6">
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      :placeholder="$t('Start Date')"
                      @on-open="focus"
                      @on-close="blur"
                      :config="picker_config"
                      class="form-control datepicker"
                      v-model="cur_start_dt"
                    >
                    </flat-picker>
                  </base-input>
                </el-col>
                <el-col :span="6">
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      :placeholder="$t('End Date')"
                      @on-open="focus"
                      @on-close="blur"
                      :config="picker_config"
                      class="form-control datepicker"
                      v-model="cur_end_dt"
                    >
                    </flat-picker>
                  </base-input>
                </el-col>
                <el-col :span="6">
                  <select class="form-control" v-model="cur_FromLocationID">
                    <option value="">{{ $t("From Store") }}</option>
                    <option
                      v-for="(dt, idx) in storelist"
                      :key="idx"
                      :value="dt.LocationID"
                    >
                      {{ dt.LocationID }} - {{ dt.LocationName }}
                    </option>
                  </select>
                </el-col>
                <el-col :span="6">
                  <select class="form-control" v-model="cur_ToLocationID">
                    <option value="">{{ $t('To Store') }}</option>
                    <option
                      v-for="(dt, idx) in storelist"
                      :key="idx"
                      :value="dt.LocationID"
                    >
                      {{ dt.LocationID }} - {{ dt.LocationName }}
                    </option>
                  </select>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <select class="form-control" v-model="cur_CreateBy">
                    <option :value="0">{{ $t("Select Creator") }}</option>
                    <option
                      v-for="(dt, idx) in useridxlist"
                      :key="idx"
                      :value="dt.IDn"
                    >
                      {{ dt.UserName }}
                    </option>
                  </select>
                </el-col>
                <el-col :span="6">
                  <select class="form-control" v-model="cur_Status">
                    <option value="">{{ $t('Select Status') }}</option>
                    <option value="Draft">{{ $t('Draft') }}</option>
                    <option value="Pending">{{ $t('Pending') }}</option>
                    <option value="Post">{{ $t('Complete') }}</option>
                    <option value="Delete">{{ $t('Delete') }}</option>
                  </select>
                </el-col>
                <el-col :offset="6" :span="6">
                  <el-button
                    type="primary"
                    class="mt-2"
                    icon="el-icon-search"
                    size="small"
                    @click="get_transfer_list"
                    >{{ $t("Search") }}</el-button
                  >
                  <el-button
                    type="primary"
                    class="mt-2"
                    icon="el-icon-plus"
                    size="small"
                    @click="add_transfer"
                    v-acl:TransferEdit.enable.show
                    >{{ $t("Add") }}</el-button
                  >
                </el-col>
              </el-row>
            </b-form>
          </b-card>
          <b-card>
            <div></div>
            <p class="p-3" v-if="transferlist">
              <el-table
                stripe
                class="table-responsive table"
                header-row-class-name="thead-light"
                :data="transferlist"
                @row-click="row_clicked_event"
              >
                <el-table-column
                  :label="$t('From')"
                  prop="FromLocationID"
                  width="200px"
                >
                  <template v-slot="{ row }">
                    {{ row.FromLocationID }} - {{ row.FromLocationName }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('To')" prop="ToLocationID" width="200px">
                  <template v-slot="{ row }">
                    {{ row.ToLocationID }} - {{ row.ToLocationName }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Order')" prop="OrderID"></el-table-column>
                <el-table-column
                  :label="$t('Transfer Date')"
                  prop="InboundDate"
                ></el-table-column>
                <el-table-column
                  :label="$t('Create By')"
                  prop="CreateName"
                ></el-table-column>
                <el-table-column :label="$t('Status')" prop="Status"></el-table-column>
                <el-table-column
                  :label="$t('Remarks')"
                  prop="Remarks"
                ></el-table-column>
              </el-table>
              <b-pagination
                v-model="current_page"
                :total-rows="product_total"
                :per-page="per_page"
              ></b-pagination>
            </p>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col> </b-col>
      </b-row>
    </b-container>
    <b-modal
      ref="my-modal"
      :title="$t('Transfer Detail')"
      id="transfer_modal"
      size="xl"
      @hidden="detail_hidden"
    >
      <form v-if="cur_order">
        <el-row :gutter="10">
          <el-col :span="6">
            <b-input-group :prepend="$t('Order #')+' : '">
              <b-form-input
                v-model="cur_order.OrderID"
                disabled
              ></b-form-input>
            </b-input-group>
          </el-col>
          <el-col :span="6">
            <b-input-group :prepend="$t('From Store')+' : '">
              <select
                class="form-control"
                v-model="cur_order_from_location_id"
                v-if="cur_order.Status == 'Draft'"
                @change="get_store_product"
              >
                <option value=""></option>
                <option
                  v-for="(dt, idx) in storelist"
                  :key="idx"
                  :value="dt.LocationID"
                >
                  {{ dt.LocationID }} - {{ dt.LocationName }}
                </option>
              </select>
              <b-form-input
                :value="cur_order.FromLocationID"
                v-else
                disabled
              ></b-form-input>
            </b-input-group>
          </el-col>
          <el-col :span="6">
            <b-input-group :prepend="$t('To Store')+' : '">
              <select
                class="form-control"
                v-model="cur_order.ToLocationID"
                v-if="cur_order.Status == 'Draft'"
                @change="ToLocationChange"
              >
                <option value=""></option>
                <option
                  v-for="(dt, idx) in storelist"
                  :key="idx"
                  :value="dt.LocationID"
                >
                  {{ dt.LocationID }} - {{ dt.LocationName }}
                </option>
              </select>
              <b-form-input
                :value="cur_order.ToLocationID"
                v-else
                disabled
              ></b-form-input>
            </b-input-group>
          </el-col>
          <el-col :span="6">
            <b-input-group :prepend="$t('Remarks')+' : '">
              <b-form-input
                v-model="cur_order.Remarks"
                :disabled="cur_order.Status == 'Post' || cur_order.Status == 'Delete'"
              ></b-form-input>
            </b-input-group>
          </el-col>
        </el-row>
        <el-row :gutter="10" v-if="cur_order.Status != 'Draft'">
          <el-col :span="6">
            <b-input-group :prepend="('Create By')+' : '">
              <b-form-input
                v-model="cur_order.CreateName"
                disabled
              ></b-form-input>
            </b-input-group>
          </el-col>
          <el-col :span="6">
            <b-input-group :prepend="$t('Update By')+' : '">
              <b-form-input
                v-model="cur_order.UpdateName"
                disabled
              ></b-form-input>
            </b-input-group>
          </el-col>
        </el-row>
        <hr />
        <el-row :gutter="5" v-if="cur_order.Status == 'Draft'">
          <el-col :span="6">
            <b-input-group :prepend="'PLU/'+$t('Barcode')+'/'+$t('Name')+': '">
              <b-form-input
                v-model="cur_search_input"
                @keyup="delay_search_product"
              ></b-form-input>
            </b-input-group>
          </el-col>
          <el-col :span="6">
            <b-input-group :prepend="$t('Department')+': '">
              <select
                class="form-control"
                v-model="cur_search_departmentIDn"
                @change="changed_department"
              >
                <option :value="0"></option>
                <option
                  v-for="(dt, idx) in idxproductlist"
                  :key="idx"
                  :value="dt.IDn"
                >
                  {{ dt.Name1 }} - {{ dt.Name2 }}
                </option>
              </select>
            </b-input-group>
          </el-col>
          <el-col :span="6">
            <b-input-group :prepend="$t('Category')+': '">
              <select
                class="form-control"
                v-model="cur_search_categoryIDn"
                @change="changed_category"
              >
                <option :value="0"></option>
                <option
                  v-for="(dt, idx) in cur_searched_categorys"
                  :key="idx"
                  :value="dt.IDn"
                >
                  {{ dt.Name1 }} - {{ dt.Name2 }}
                </option>
              </select>
            </b-input-group>
          </el-col>
        </el-row>
        <section
          v-if="cur_listed_products.length > 0 && show_listed_products"
          class="transfer_product_section"
        >
          <el-table
            stripe
            class="table-responsive table"
            style="width: 100%"
            header-row-class-name="thead-light"
            :data="cur_listed_products"
            @row-click="add_order_product"
          >
            <el-table-column
              width="120"
              label="PLU"
              prop="PLU"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$t('Name')"
              align="left"
            >
              <template slot-scope="scope">
                {{ scope.row.Name2 ? scope.row.Name1+" - "+scope.row.Name2 : scope.row.Name1 }}
              </template>
            </el-table-column>
            <el-table-column
              width="80"
              :label="$t('Unit')"
              prop="Unit"
              align="center"
            ></el-table-column>
            <el-table-column
              width="80"
              :label="$t('Qty')"
              prop="InventoryQty"
              align="right"
            ></el-table-column>
            <el-table-column
              width="130"
              :label="$t('On Order')"
              prop="OnOrderQty"
              align="right"
            ></el-table-column>
            <el-table-column
              width="130"
              :label="$t('On Hold')"
              prop="OnHoldQty"
              align="right"
            ></el-table-column>
            <el-table-column width="80" label="" align="center">
              <template slot="header">
                <base-button
                  type="primary"
                  size="sm"
                  v-if="show_listed_products"
                  class="mt-1"
                  @click="show_listed_products = false"
                  >{{ $t("Hide") }}</base-button
                >
              </template>
              <template>
                <base-button type="primary" size="sm" icon>
                  <span class="btn-inner--icon"
                    ><i class="ni ni-fat-add"></i
                  ></span>
                  <span class="btn-inner--text"></span>
                </base-button>
              </template>
            </el-table-column>
          </el-table>
        </section>
        <hr />
        <!-- product search and add -->
        <el-row :gutter="5">
          <el-col :span="3">
            <div class="product_head">PLU</div>
          </el-col>
          <el-col :span="6">
            <div class="product_head">{{ $t("Product Name") }}</div>
          </el-col>
          <el-col :span="3">
            <div class="product_head">{{ $t("Cost") }}</div>
          </el-col>
          <el-col :span="3">
            <div class="product_head">{{ $t("Qty") }}</div>
          </el-col>
          <el-col :span="3">
            <div class="product_head">{{ $t("Unit") }}</div>
          </el-col>
          <el-col :span="3">
            <div class="product_head">{{ $t("Subtotal") }}</div>
          </el-col>
          <el-col :span="2">
            <div class="product_head">{{ "S/N" }}</div>
          </el-col>
        </el-row>
        <el-row
          :gutter="5"
          v-for="(prod, idx) in computed_products"
          :key="idx"
          class="product_row"
        >
          <el-col :span="3">
            <div>{{ prod.PLU }}</div>
          </el-col>
          <el-col :span="6">
            <div v-if="prod.Status == 'Delete'" style="text-decoration: line-through">
              {{ prod.Name1 }} - {{ prod.Name2 }}
            </div>
            <div v-else>
              {{ prod.Name1 }} - {{ prod.Name2 }}
            </div>
          </el-col>
          <el-col :span="3">
            <div>{{ prod.UnitCost }}</div>
          </el-col>
          <el-col :span="3">
            <div v-if="cur_order.Status == 'Draft'">
              <div class="el-input el-input--mini">
                <input
                  type="text"
                  autocomplete="off"
                  class="el-input__inner"
                  v-model="prod.Qty"
                  @keyup="qty_change($event, prod)"
                />
              </div>

            </div>
            <div v-else>{{ prod.Qty }}</div>
          </el-col>
          <el-col :span="3">
            <div>{{ prod.Unit }}</div>
          </el-col>
          <el-col :span="3">
            <div>{{ prod.Cost ? prod.Cost : 0 }}</div>
          </el-col>
          <el-col :span="2">
            <div v-if="parseInt(prod.HasSerialNumber) == 1" @click="selectSN(prod)">
              <i class="el-icon-connection hover_hand red_color"></i>
            </div>
            <div v-else>
              {{ "-" }}
            </div>
          </el-col>
          <el-col :span="1">
            <i
              class="el-icon-close"
              v-if="cur_order.Status == 'Draft'"
              @click="remove_product(prod)"
            ></i>
          </el-col>
        </el-row>
        <el-row class="summary_row">
          <el-col :offset="7" :span="5">
            <div>{{ $t("Summary") + ":" }}</div>
          </el-col>
          <el-col :span="3">
            <div>{{ cur_order.summary_Qty ? cur_order.summary_Qty : "" }}</div>
          </el-col>
          <el-col :offset="3" :span="3">
            <div>{{ cur_order.summary_Total ? cur_order.summary_Total : "" }}</div>
          </el-col>
        </el-row>
      </form>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger"
          v-if="cur_order.IDn > 0 && cur_order.Status == 'Draft'"
          @click="form_submit('Delete')"
        >
          {{ $t('Delete') }}
        </button>
        <button
          type="button"
          class="btn btn-success"
          v-if="cur_order.Status == 'Draft'"
          @click="form_submit('Pending')"
        >
          {{ $t('Pending') }}
        </button>
        <button
          type="button"
          class="btn btn-success"
          v-if="cur_order.Status == 'Pending'"
          @click="form_submit('Post')"
        >
          {{ $t('Complete') }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          v-if="cur_order.Status == 'Draft'"
          @click="form_submit('Draft')"
        >
          {{ $t('Draft') }}
        </button>
        <button type="button" class="btn btn-secondary" @click="close_my_modal">
          {{ $t('Close') }}
        </button>
      </template>
    </b-modal>
    
    <!-- SN select dialogue -->
    <b-modal
      ref="select-sn-modal"
      :title="$t('Input S/N')"
      id="select-sn-modal"
      size="sm"
      @shown="sn_shown"
    >
      <div v-if="cur_prod && cur_prod.Status == 'Draft'">
        <el-row>
          <el-col :span="18">
            <b-input class="form-control" v-model="input_SN" @keyup.enter.native="searchSN"/>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" icon="el-icon-plus" @click="searchSN" style="margin-left: 20px"></el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-table
            id="selectSNTable"
            ref="selectSNTable"
            stripe
            class="table-responsive table product-table mt-2"
            style="width: 100%"
            height="300"
            header-row-class-name="thead-light"
            :data="display_SN_array"
            :empty-text="$t('No Records')"
            @select="selectSNChange"
            @select-all="selectSNAll"
          >
            <el-table-column type="selection" width="60">
            </el-table-column>
            <el-table-column :label="$t('Serial Number')">
              <template slot-scope="scope">
                {{ scope.row.SN }}
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row v-if="cur_prod">
          {{tmp_selected_sn.length}} / {{ parseInt(cur_prod.Qty) }}
        </el-row>
      </div>
      <div v-else>
        <el-row>
          <el-table
            stripe
            class="table-responsive table product-table mt-2"
            style="width: 100%"
            height="300"
            header-row-class-name="thead-light"
            :data="tmp_selected_sn"
            :empty-text="$t('No Records')"
          >
            <el-table-column :label="$t('Serial Number')">
              <template slot-scope="scope">
                {{ scope.row }}
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row v-if="cur_prod">
          {{tmp_selected_sn.length}} / {{ parseInt(cur_prod.OrderQty) }}
        </el-row>
      </div>
      <template #modal-footer>
        <button type="button" class="btn btn-primary" @click="submit_sn">
          {{ $t('Submit') }}
        </button>
        <button type="button" class="btn btn-secondary" @click="close_select_sn_model">
          {{ $t('Close') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Button,
  Pagination,
  Collapse,
  CollapseItem,
  Tag,
  Row,
  Col,
} from "element-ui";

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { getStore, setStore } from "../../util/helper";
import { hasUtilityAuth } from "../../directives/acl";

const axios = require("axios");

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Tag.name]: Tag,
    [Row.name]: Row,
    [Col.name]: Col,
    [Pagination.name]: Pagination,
    flatPicker,
  },
  data() {
    return {
      input_SN: "",
      display_SN_array: [],
      cur_prod: null,
      tmp_selected_sn: [],

      cur_order: null,
      cur_order_from_location_id: null,
      cur_opt: null,
      cur_search_input: "",
      cur_search_departmentIDn: 0,
      cur_search_categoryIDn: 0,
      cur_searched_categorys: [],
      cur_searched_products: [],
      cur_listed_products: [],
      show_listed_products: true,
      delay_search_timer: null,

      cur_Products: [],

      new_order: {
        IDn: 0,
        OrderID: "",
        FromLocationID: "",
        ToLocationID: "",
        TransferDate: "",
        CompleteDate: "",
        InboundIDn: 0,
        OutboundIDn: 0,
        InboundNo: "",
        OutboundNo: "",
        InboundDate: null,
        OutboundDate: null,
        SubTotal: 0,
        TotalTAX: 0,
        TotalAmount: 0,
        CreateBy: 0,
        UpdateBy: 0,
        Status: "Draft",
        Remarks: "",
      },
      transferlist: null,
      productlist: null,
      brandlist: null,
      storelist: null,
      useridxlist: null,
      idxproductlist: [],

      cur_start_dt: 0,
      cur_end_dt: 0,
      cur_TransferDate: "",
      cur_FromLocationID: "",
      cur_ToLocationID: "",
      cur_CreateBy: 0,
      cur_OrderID: "",
      cur_Status: "", // Draft Pending Post Delete
      cur_Remarks: "",

      today: "",

      delay_timer: null,

      current_page: 1,
      product_total: 0,
      per_page: 20,

      picker_config: {
        allowInput: true,
        dateFormat: "Y-m-d",
        altFormat: "Y-m-d",
        maxDate: "today", // New Date();  YYYY-MM-DD HH:MM
      },
      picker_config2: {
        allowInput: true,
        dateFormat: "Y-m-d",
        altFormat: "Y-m-d",
      },
      backcolor1: {
        backgrondColor: "#ffff00",
      },
      backcolor2: {
        backgrondColor: "#ee00ee",
      },
      token: "",
      user_id: 0,
    };
  },
  watch: {
    current_page: function (newval, oldval) {
      this.get_transfer_list_delay();
    },
  },
  computed: {
    apiBaseUrl: function () {
      return axios.defaults.baseURL + "/Api";
    },
    computed_products: function () {
      let tmp = [];
      if (this.cur_Products) {
        for (let i = 0; i < this.cur_Products.length; i++) {
          if (this.cur_Products[i]["Status"] != "Delete") {
            tmp.push(this.cur_Products[i]);
          }
        }
      }
      return tmp;
    }
  },
  methods: {
    hasUtilityAuth,
    qty_change(event, prod) {
      if (!Number(prod.Qty) || prod.Qty.startsWith('-')) {
        let chars = prod.Qty.split('');
        for (let i = chars.length - 1; i >= 0; i--) {
          if (
            (
              !Number(chars[i])
              && chars[i] != '0' 
              && chars[i] != '.'
            )
            || chars[i] == '-'
          ) {
            chars.splice(i, 1);
          }
        }
        prod.Qty = chars.join('');
      }
      if (prod.Qty.split('.').length > 2) {
        prod.Qty = prod.Qty.split('.')[0] + '.' + prod.Qty.split('.')[1];
      }
      if((prod.Qty.split('.').length > 1 && prod.Qty.split('.')[1].length > 2)) {
        prod.Qty = parseFloat(prod.Qty).toFixed(2);
      }
      this.calculate_recodes(prod);
    },
    ToLocationChange() {
      for (let i = 0; i < this.cur_Products.length; i++) {
        this.cur_Products[i].ToLocationID = this.cur_order.ToLocationID;
      }
    },
    detail_hidden() {
      this.cur_search_input = "";
      this.cur_search_departmentIDn = 0;
      this.cur_search_categoryIDn = 0;
      this.cur_searched_products = [];
    },
    add_transfer() {
      this.cur_order = JSON.parse(JSON.stringify(this.new_order));
      this.cur_order_from_location_id = this.cur_order.FromLocationID;
      this.cur_Products = [];
      this.apply_order_calculate();
      this.get_product(function(that, data) {
        that.idxproductlist = data.idxproducts;
        that.cur_Products = data.products;
        that.search_product();
        that.apply_order_calculate();
        that.show_listed_products = true;
        that.$refs["my-modal"].show();
      });
    },
    close_my_modal() {
      this.$refs["my-modal"].hide();
    },
    apply_order_calculate() {
      let SubTotal = 0;
      let TotalTAX = 0;
      let summary_Qty = 0
      let summary_Total = 0
      for (let i = 0; i < this.cur_Products.length; i++) {
        let prod = this.cur_Products[i];
        if (prod.Status == "Delete") continue;
        if (parseFloat(prod.Cost)) {
          SubTotal += parseFloat(prod.Cost);
        }
        if (parseFloat(prod.Qty) && parseFloat(prod.Cost)) {
          summary_Qty += parseFloat(prod.Qty);
          summary_Total += parseFloat(prod.Cost);
        }
      }
      let TotalAmount = SubTotal + TotalTAX;
      this.cur_order.SubTotal = SubTotal.toFixed(2);
      this.cur_order.TotalTAX = TotalTAX.toFixed(2);
      this.cur_order.TotalAmount = TotalAmount.toFixed(2);
      this.cur_order["summary_Qty"] = summary_Qty.toFixed(2);
      this.cur_order["summary_Total"] = summary_Total.toFixed(2);
    },
    remove_product(prod) {
      for (var i = this.cur_Products.length - 1; i >= 0; i--) {
        if (this.cur_Products[i] == prod) {
          if (prod.IDn == 0) {
            this.cur_Products.splice(i, 1);
          } else {
            prod.Status = "Delete";
          }
        }
      }
      this.apply_order_calculate();
    },
    calculate_recodes(prod) {
      prod.Cost = 0;
      prod.Price = 0;
      if (parseFloat(prod.UnitCost) && parseFloat(prod.Qty)) {
        prod.Cost = (parseFloat(prod.UnitCost) * parseFloat(prod.Qty)).toFixed(2);
      }
      if (parseFloat(prod.UnitPrice) && parseFloat(prod.Qty)) {
        prod.Price = (parseFloat(prod.UnitPrice) * parseFloat(prod.Qty)).toFixed(2);
      }
      this.apply_order_calculate();
    },
    async get_system_sn(productidn, from_locationid, to_locationid = "", func = function() {}) {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("ProductIDn", productidn);
      bodyFormData.append("FromLocationID", from_locationid);
      if (to_locationid) {
        bodyFormData.append("ToLocationID", to_locationid);
      }

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Inventory/Transfer/system_sn",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              func(that, rt.data);
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    add_order_product(row, column, event) {
      event.preventDefault();
      if (column.label != "") {
        return;
      }
      if (this.cur_Products.length > 0) {
        // Check Product existing
        for (var i = 0; i < this.cur_Products.length; i++) {
          if (this.cur_Products[i].Status != 'Delete' && this.cur_Products[i].ProductIDn == row.IDn) {
            // Find existed, no add
            return;
          }
        }
      }

      let func = function (that, data = null) {
        let prod = {
          IDn: 0,
          TransferIDn: that.cur_order.IDn, // if not valid, add after pktransfer is saved
          TransferNo: that.cur_order.OrderID, // if not valid, add after pktransfer is saved
          FromLocationID: that.cur_order.FromLocationID,
          ToLocationID: that.cur_order.ToLocationID,
          FromInventoryIDn: row.InventoryIDn ? row.InventoryIDn : 0, // 
          ToInventoryIDn: (data && data.ToInventoryIDn) ? data.ToInventoryIDn : 0, // should be updated at the transfer product add/update
          ProductIDn: row.IDn,
          Name1: row.Name1,
          Name2: row.Name2,
          PLU: row.PLU,
          Unit: row.Unit,
          HasSerialNumber: parseInt(row.HasSerialNumber),
          UnitPrice: row.LocationPrice ? row.LocationPrice : row.APrice,
          UnitCost: row.LocationCost ? row.LocationPrice : 0,
          Qty: 1,
          Cost: 0, // calculation client side
          Price: 0, // calculation client side
          Status: "Draft", // Delete, Post, Draft, Pending
          Remarks: "",
          SerialNumber: row.SerialNumber ? JSON.parse(row.SerialNumber) : "", // 
          ReferenceIDn: 0,
        };
        if ((parseInt(row.HasSerialNumber) == 1) && data && data.SystemSN && data.SystemSN.length > 0) {
          prod["SystemSN"] = data.SystemSN;
        }
        that.calculate_recodes(prod);
        that.cur_Products.unshift(prod);
        that.apply_order_calculate();
      };

      if ((parseInt(row.HasSerialNumber) == 1) && row.IDn) {
        this.get_system_sn(row.IDn, 
          this.cur_order.FromLocationID, 
          this.cur_order.ToLocationID, 
          func);
      } else {
        func(this);
      }

    },
    delay_search_product() {
      if (this.delay_search_timer) {
        clearTimeout(this.delay_search_timer);
        this.delay_search_timer = null;
      }
      var that = this;
      this.delay_search_timer = setTimeout(() => {
        that.search_product(true);
      }, 400);
    },
    matching_product(prod) {
      if (prod.PLU.search(this.cur_search_input) >= 0) {
        return true;
      }
      if (prod.Barcode.search(this.cur_search_input) >= 0) {
        return true;
      }
      if (prod.Name1.search(this.cur_search_input) >= 0) {
        return true;
      }
      if (prod.Name2.search(this.cur_search_input) >= 0) {
        return true;
      }
      return false;
    },
    search_product(force_show = false) {
      this.cur_listed_products = [];
      if (force_show) this.show_listed_products = true;

      if (this.cur_searched_products == null || this.cur_searched_products.length <= 0) {
        if (this.cur_search_input.length < 2) {
          for (var i = 0; i < this.idxproductlist.length; i++) {
            for (var j = 0; j < this.idxproductlist[i].Categorys.length; j++) {
              for (
                var k = 0;
                k < this.idxproductlist[i].Categorys[j].Products.length;
                k++
              ) {
                this.cur_listed_products.push(
                  this.idxproductlist[i].Categorys[j].Products[k]
                );
              }
            }
          }
          return;
        } else {
          for (var i = 0; i < this.idxproductlist.length; i++) {
            for (var j = 0; j < this.idxproductlist[i].Categorys.length; j++) {
              for (
                var k = 0;
                k < this.idxproductlist[i].Categorys[j].Products.length;
                k++
              ) {
                if (
                  this.matching_product(
                    this.idxproductlist[i].Categorys[j].Products[k]
                  )
                ) {
                  this.cur_listed_products.push(
                    this.idxproductlist[i].Categorys[j].Products[k]
                  );
                }
              }
            }
          }
          return;
        }
      }
      if (this.cur_searched_products.length > 0) {
        if (this.cur_search_input.length < 2) {
          this.cur_listed_products = this.cur_searched_products.slice();
          return;
        } else {
          for (var i = 0; i < this.cur_searched_products.length; i++) {
            if (this.matching_product(this.cur_searched_products[i])) {
              this.cur_listed_products.push(this.cur_searched_products[i]);
            }
          }
          return;
        }
      } else {
        return;
      }
    },
    get_product(func = function() {}) {
      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("IDn", this.cur_order.IDn);
      bodyFormData.append("FromLocationID", this.cur_order_from_location_id);

      var that = this;

      axios({
        method: "post",
        url: "/Api/Web/Inventory/Transfer/product",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              func(that, rt.data);
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    check_product_from_location(idxproductlist) {
      let prod_list = new Object();
      for (var i = 0; i < idxproductlist.length; i++) {
        for (var j = 0; j < idxproductlist[i].Categorys.length; j++) {
          for (var k = 0; k < idxproductlist[i].Categorys[j].Products.length; k++) {
            prod_list[idxproductlist[i].Categorys[j].Products[k]["IDn"]] = 
              idxproductlist[i].Categorys[j].Products[k];
          }
        }
      }

      let errMsg = "";
      let err_chk_inv = false;
      let err_chk_qty = false;
      let err_chk_sn = false;
      for (let i = 0; i < this.cur_Products.length; i++) {
        if (this.cur_Products[i]["Status"] == "Delete") continue;
        let idn = this.cur_Products[i]["ProductIDn"];
        if (!prod_list[idn] || !prod_list[idn]["InventoryIDn"]) {
          err_chk_inv = true;
          this.cur_Products[i]["pre_delete"] = 1;
        }
        if (prod_list[idn] && prod_list[idn]["InventoryIDn"] && (
            !prod_list[idn]["InventoryQty"] || prod_list[idn]["InventoryQty"] < this.cur_Products[i]["Qty"]
          )
        ) {
          err_chk_qty = true;
          this.cur_Products[i]["pre_delete"] = 1;
        }
        if (prod_list[idn] && (parseInt(prod_list[idn]["HasSerialNumber"]) == 1)) {
          err_chk_sn = true;
          this.cur_Products[i]["pre_delete"] = 1;
        }
      }
      
      if (err_chk_inv) errMsg += "There are products not avalable for the From Location. \n";
      if (err_chk_qty) errMsg += "There are products not sufficient for the From Location. \n";
      if (err_chk_sn) errMsg += "There are products with Serial Number management. \n";
      if (errMsg) errMsg += "\nIf click \"OK\", you agree on deleting the products; or \"Cancel\", the From Location will be revised.";
      if (errMsg) {
        if (confirm(errMsg)) {
          for (let i = this.cur_Products.length - 1; i >= 0; i--) {
            if (this.cur_Products[i]["pre_delete"]) {
              if (this.cur_Products[i]["IDn"]) {
                this.cur_Products[i]["Status"] = "Delete";
                delete this.cur_Products[i]["pre_delete"];
              } else {
                this.cur_Products.splice(i, 1);
              }
            }
          }
        } else {
          for (let i = 0; i < this.cur_Products.length; i++) {
            if (this.cur_Products[i]["pre_delete"]) {
              delete this.cur_Products[i]["pre_delete"];
            }
          }
          return false;
        }
      }
      for (let i = 0; i < this.cur_Products.length; i++) {
        this.cur_Products[i]["FromLocationID"] = this.cur_order_from_location_id;
        this.cur_Products[i]["FromInventoryIDn"] = prod_list[this.cur_Products[i]["ProductIDn"]]["InventoryIDn"];
      }
      return true;
    },
    get_store_product() {
      this.get_product( function (that, data) {
        if (that.check_product_from_location(data.idxproducts)) {
          that.idxproductlist = data.idxproducts;
          that.cur_order.FromLocationID = that.cur_order_from_location_id;
        } else {
          that.cur_order_from_location_id = that.cur_order.FromLocationID;
        }
        that.search_product();
        that.apply_order_calculate();
        that.show_listed_products = true;
      });
    },
    search_department(dept) {
      return dept.IDn == this.cur_search_departmentIDn;
    },
    changed_department() {
      this.cur_searched_categorys = [];
      this.cur_search_categoryIDn = 0;
      if (this.cur_search_departmentIDn == 0) {
        this.changed_category();
        return;
      }
      let findout = this.idxproductlist.find(this.search_department);
      if (findout == undefined) {
        this.changed_category();
        return;
      }
      this.cur_searched_categorys = findout.Categorys;
      this.changed_category();
    },
    search_category(cate) {
      return cate.IDn == this.cur_search_categoryIDn;
    },
    changed_category() {
      this.cur_searched_products = [];
      if (!this.cur_search_categoryIDn) {
        if (!this.cur_search_departmentIDn) {
          this.cur_searched_products = null;
          this.delay_search_product();
          return;
        }
        for (let i in this.cur_searched_categorys) {
          this.cur_searched_products.push(...this.cur_searched_categorys[i].Products);
        }
        this.delay_search_product();
      }
      let findout = this.cur_searched_categorys.find(this.search_category);
      if (findout == undefined) {
        this.delay_search_product();
        return;
      }
      this.cur_searched_products = findout.Products;
      this.delay_search_product();
    },
    row_clicked_event(row, column, event) {
      if (!hasUtilityAuth('TransferEdit')) return;
      event.preventDefault();
      this.cur_order = JSON.parse(JSON.stringify(row));
      this.cur_order_from_location_id = this.cur_order.FromLocationID;
      this.get_product(function(that, data) {
        that.idxproductlist = data.idxproducts;
        that.cur_Products = data.products;
        that.search_product();
        that.apply_order_calculate();
        that.show_listed_products = false;
        that.$refs["my-modal"].show();
      });
    },
    async form_submit(Status) {
      if (this.cur_order.FromLocationID == "") {
        alert("Please choose From Store");
        return;
      } else if (this.cur_order.ToLocationID == "") {
        alert("Please choose To Store");
        return;
      } else if (this.cur_order.FromLocationID == this.cur_order.ToLocationID) {
        alert("You have chosen the same To Store as the From Store");
        return;
      }
      
      if (Status == "Pending" || Status == "Post") {
        if (!this.cur_Products || !this.cur_Products.length) {
          alert("Please add products");
          return;
        }
        for (let i = 0; i < this.cur_Products.length; i++) {
          let prod = this.cur_Products[i];
          if (parseInt(prod.HasSerialNumber) == 1) {
            if (prod.SerialNumber) {
              if (prod.SerialNumber.length != parseInt(prod.Qty)) {
                let name = (prod.Name1 ? prod.Name1 : "") + " - " +(prod.Name2 ? prod.Name2 : "");
                alert("Serial Number count not match (" + name + ")");
                return;
              }
            } else {
              let name = (prod.Name1 ? prod.Name1 : "") + " - " +(prod.Name2 ? prod.Name2 : "");
              alert("Serial Number is not added (" + name + ")");
              return;
            }
          }
        }
      }

      this.apply_order_calculate();

      this.cur_order.UpdateBy = this.user_id;
      this.cur_order.Status = Status;
      if (this.cur_order.IDn == 0) {
        this.cur_order.TransferBy = this.user_id;
        this.cur_order.CreateBy = this.user_id;
        this.cur_order.TransferDate = this.today;
      }

      for (let i = 0; i < this.cur_Products.length; i++) {
        if (
          this.cur_Products[i].Status == "Draft" ||
          this.cur_Products[i].Status == "Pending"
        ) {
          this.cur_Products[i].Status = Status;
        }
      }

      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);

      var that = this;
      for (var key in this.cur_order) {
        if (this.cur_order[key]) {
          bodyFormData.append(key, this.cur_order[key]);
        }
      }

      bodyFormData.append("Products", JSON.stringify(this.cur_Products));

      axios({
        method: "post",
        url: "/Api/Web/Inventory/Transfer/update",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.close_my_modal();
              that.get_transfer_list();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    get_transfer_list_delay() {
      if (this.delay_timer) {
        clearTimeout(this.delay_timer);
        this.delay_timer = null;
      }
      var that = this;
      this.delay_timer = setTimeout(() => {
        that.get_transfer_list();
      }, 400);
    },
    async get_transfer_list() {
      if (this.delay_timer) {
        clearTimeout(this.delay_timer);
        this.delay_timer = null;
      }

      var bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      if (this.cur_TransferDate) {
        bodyFormData.append("InboundDate", this.cur_TransferDate);
      }
      if (this.cur_start_dt) {
        bodyFormData.append("StartDate", this.cur_start_dt);
      }
      if (this.cur_end_dt) {
        bodyFormData.append("EndDate", this.cur_end_dt);
      }
      if (this.cur_FromLocationID) {
        bodyFormData.append("FromLocationID", this.cur_FromLocationID);
      }
      if (this.cur_ToLocationID) {
        bodyFormData.append("ToLocationID", this.cur_ToLocationID);
      }
      if (this.cur_CreateBy) {
        bodyFormData.append("CreateBy", this.cur_CreateBy);
      }
      if (this.cur_OrderID) {
        bodyFormData.append("OrderID", this.cur_OrderID);
      }
      if (this.cur_Status) {
        bodyFormData.append("Status", this.cur_Status);
      }
      if (this.cur_Remarks) {
        bodyFormData.append("Remarks", this.cur_Remarks);
      }
      bodyFormData.append("page", this.current_page);
      bodyFormData.append("per_page", this.per_page);

      var that = this;
      axios({
        method: "post",
        url: "/Api/Web/Inventory/Transfer",
        data: bodyFormData,
      })
        .then(function (response) {
          if (response.status == "200") {
            var rt = response.data;
            if (rt.status == 0) {
              that.transferlist = rt.data.transfers;
              (that.storelist = rt.data.stores),
                (that.useridxlist = rt.data.users),
                (that.transfer_total = rt.data.transfer_total);
              that.per_page = rt.data.per_page;
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          } else {
            that.$router.push("/login");
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$router.push("/login");
        });
    },
    table_load_sn() {
      this.$refs["selectSNTable"].clearSelection();
      let _tmp = JSON.parse(JSON.stringify(this.tmp_selected_sn));
      for (let i in _tmp) {
        for (let j in this.display_SN_array) {
          if (this.display_SN_array[j].SN == _tmp[i]) {
            this.$refs["selectSNTable"].toggleRowSelection(this.display_SN_array[j]);
          }
        }
      }
    },
    sn_shown(e) {
      if (this.cur_prod && this.cur_prod.Status == "Draft") {
        this.table_load_sn();
      }
    },
    selectSN(product) {
      this.cur_prod = product;
      this.input_SN = "";

      if(product.SystemSN){
        if(Array.isArray(product.SystemSN)) {
          this.display_SN_array = JSON.parse(JSON.stringify(product.SystemSN));
        } else {
          this.display_SN_array = JSON.parse(product.SystemSN);
        }
      } else {
        this.display_SN_array = [];
        alert("No S/N found for this product");
        return;
      }
      if(product.SerialNumber){
        if(Array.isArray(product.SerialNumber)){
          this.tmp_selected_sn = JSON.parse(JSON.stringify(product.SerialNumber));
        } else {
          this.tmp_selected_sn = JSON.parse(product.SerialNumber);
        }
      } else {
        this.tmp_selected_sn = [];
      }

      this.$refs["select-sn-modal"].show();
    },
    selectSNChange(val, row) {
      if (val.length > this.cur_prod.Qty) {
        this.$refs["selectSNTable"].toggleRowSelection(row);
        alert("You cannot add S/N more than the order quantity.");
      } else {
        this.tmp_selected_sn = [];
        for (let i in val) {
          this.tmp_selected_sn.push(val[i].SN);
        }
      }
    },
    selectSNAll(val) {
      if (val.length > this.cur_prod.Qty) {
        if (this.tmp_selected_sn.length == 0) {
          this.$refs["selectSNTable"].clearSelection();
          for (let i = 0; i <= (this.cur_prod.Qty - 1); i++) {
            this.$refs["selectSNTable"].toggleRowSelection(val[i]);
            this.tmp_selected_sn.push(val[i].SN);
          }
        } else {
          this.table_load_sn();
          alert("You cannot add S/N more than the order quantity.");
        }
      } else {
        this.tmp_selected_sn = [];
        for (let i in val) {
          this.tmp_selected_sn.push(val[i].SN);
        }
      }
    },
    searchSN() {
      if (this.tmp_selected_sn.includes(this.input_SN)) {
        alert("This S/N is already selected");
        return;
      }
      let table = this.$refs.selectSNTable;
      for (let i in this.display_SN_array) {
        let sn = this.display_SN_array[i].SN;
        if (sn == this.input_SN) {
          if (this.tmp_selected_sn.length >= this.cur_prod.Qty) {
            alert("You cannot add S/N more than the order quantity.");
          } else {
            table.toggleRowSelection(this.display_SN_array[i]);
            this.tmp_selected_sn.push(sn);
            this.input_SN = "";
          }
          return;
        }
      }
      alert("Input S/N does not exist");
    },
    submit_sn() {
      if(this.cur_prod.Status == 'Draft'){
        if (this.tmp_selected_sn){
          if(Array.isArray(this.tmp_selected_sn)){
            this.cur_prod.SerialNumber = JSON.parse(JSON.stringify(this.tmp_selected_sn));
          } else {
            this.cur_prod.SerialNumber = JSON.parse(this.tmp_selected_sn);
          }
        } else {
          this.cur_prod.SerialNumber = [];
        }
      }
      this.$refs["select-sn-modal"].hide();
    },
    close_select_sn_model() {
      this.$refs["select-sn-modal"].hide();
    },
    add_changed_sn_inv(inv) {
      this.changed_sn_inv[inv.InvIDn] = inv;
    },
    async init_data() {
      this.token = getStore("token");
      this.user_id = getStore("user_id");
      var today = new Date();
      this.today =
        today.getFullYear() +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(today.getDate()).padStart(2, "0");
      this.new_order.TransferDate = this.today;

      if (!this.token || !this.user_id) {
        this.$router.push("/login");
        return;
      }
      return this.get_transfer_list();
    },
  },
  mounted() {
    this.init_data();
    this.windowHeight = window.innerHeight;
  },
};
</script>
<style>
.content {
  padding-top: 40px;
}
.search-button {
  margin-top: 2rem;
}
.select_text {
  margin-left: -1rem;
}
.card .table td {
  padding: 0.5rem;
}
.picimg {
  padding-left: 3rem;
  max-height: 6rem;
}
#transfer_modal .modal-title {
  font-size: 1.5rem;
}
#transfer_modal hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.el-collapse-item__header {
  background-color: #a5d1fa;
  font-size: 1.2rem;
  padding-left: 1rem;
}
.el-collapse-item__content {
  padding-bottom: 0.5rem;
}
.transfer_product_section {
  max-height: 12rem;
  overflow: auto;
}
.transfer_product_section .el-table td,
.el-table th {
  padding: 2px 0;
}
.product_row {
  border-top: 1px solid gray;
}
.summary_row {
  border-top: 1px solid gray;
  font-size: large;
}
.product_sn {
  max-width: 10rem;
  display: inline-flex;
}
.product_sn_col {
  max-height: 4rem;
  overflow: auto;
}
.form-group {
  margin-bottom: 0.5rem;
}
</style>
